export const recalculatePortfolio = /* GraphQL */ `
  query GetPortfolioRatioDataRealTime(
    $portfolioId: ID!
    $assetClass: String!)
  {
    getPortfolioRatioDataRealTime(portfolioId: $portfolioId, assetClass: $assetClass) {
      currentValue
      result
      yield
      timestamp
    }
  }
`
